<div class="row thankyou-text columns" *ngIf="!hidden">
	<p class="nl2br" *ngIf="eventThankYou">{{ eventThankYou }}</p>
	<p [innerHTML]="textkey | translate: placeholder" *ngIf="donation.amount > 0 || donation.extraAmount > 0 || step !== 'thankyou'"></p>
	<p *ngIf="step != 'end' && donation.giftData.isGiftDonation === true">{{ 'gift.thankyou' | translate }}</p>
</div>
